import type { JSX } from 'react';
import { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { useCandidateProfile } from '../hooks/useCandidateProfile';
import { useProfileSubmit } from '../hooks/useProfileSubmit';
import { ProfileEditForm, ProfileView } from './ProfileFormComponents';

export function CandidateProfileSection(): JSX.Element {
  const { profile, isLoading } = useCandidateProfile();
  const [isEditing, setIsEditing] = useState(false);
  const handleSubmit = useProfileSubmit((): void => setIsEditing(false));

  if (isLoading || !profile) {
    return (
      <Card>
        <CardContent className="p-6">Loading...</CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center justify-between gap-2">
          Your Profile
          <Button variant="outline" size="sm" onClick={(): void => setIsEditing(!isEditing)}>
            {isEditing ? 'Cancel' : 'Edit'}
          </Button>
        </CardTitle>
      </CardHeader>
      <CardContent>
        {isEditing ? (
          <ProfileEditForm
            profile={profile}
            onSubmit={handleSubmit}
            onCancel={(): void => setIsEditing(false)}
          />
        ) : (
          <ProfileView profile={profile} />
        )}
      </CardContent>
    </Card>
  );
}
